<div class="forward-request-container">

  <div class="header">
    <div>{{title}} </div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>
  <div class="main-container">
    <div class="form">


      @if (userIsAbsent) {
        <fi-alert tone="warning">
          <span
            fiTranslation="ACTION_LEAD_FORWARD_INFO_MESSAGE_ABSENT_USER"
            [params]="{
              absentUntil: isAbsentUntil,
              userName: isAbsentCoverUserName
            }">
          </span>
        </fi-alert>
      }

      <div class="row">
        <fi-input
          type="SELECT"
          valuePropertyPath="id"
          namePropertyPath="name"
          [replaceKeys]="true"
          [enableSearch]="true"
          [readOnly]="!unfilteredForwardedUsers"
          [selectedOptionsOrValues]="selectedValue"
          [multiLineOptionText]="true"
          [nameIsHtml]="true"
          [sectionIsHtml]="true"
          [displayedSelectedText]="displayedSelectedText"
          [options]="options"
          [sectionTextKeys]="sectionTextKeys"
          (onChange)="onSelect($event)"
          (onSearch)="onSearch($event)"
          labelKey="%ACTION_LEAD_FORWARD_HEADLINE_SELECT_USER%"
          placeholderKey="%REQUEST_DETAIL_ASSIGN_SEARCH_PLACEHOLDER%"
          >

        </fi-input>
      </div>

      @if (selectedPartner) {
        <div class="row">
          <div class="main-content">
            <div class="selected-dealer-partner" [class.white]="selectedPartner">
              <div class="result-item" >
                <div class="delete-selected-dealer" (click)="clearSelectedDealer()" >
                  <mat-icon>close</mat-icon>
                </div>
                <div>
                  <div class="kkz">{{selectedPartner.KKZ}}</div>
                  <div class="container">
                    <div>
                      @if (selectedPartner.Name) {
                        <div class="line"
                        >{{selectedPartner.Name}}</div>
                      }
                      @if (selectedPartner.Address?.Address) {
                        <div class="line"
                        >{{selectedPartner.Address.Address}}</div>
                      }
                      @if (selectedPartner.Address?.City || selectedPartner.Address?.ZipCode) {
                        <div class="line"
                        >{{selectedPartner.Address.ZipCode}} {{ selectedPartner.Address.City }}</div>
                      }
                      @if (selectedPartner.Address?.Country) {
                        <div class="line"
                        >{{selectedPartner.Address.Country}}</div>
                      }
                      @if (selectedPartner.Address?.Phone) {
                        <div class="line phone"
                        >{{selectedPartner.Address.Phone}}</div>
                      }
                      @if (selectedPartner?.Email) {
                        <div class="line email"
                        >{{selectedPartner.Email}}</div>
                      }
                    </div>
                    <div>
                      @if (selectedPartner.ContactManagers[0] && false) {
                        <div class="manager-container ContactManager">
                          <img alt="Contact" src="{{selectedPartner.ContactManagers[0].AvatarURL}}">
                          <div class="manager-info">
                            <div class="line">Zuständiger Kontaktmanager:</div>
                            <!-- *ngIf="selectedPartner.ContactManager?.Organisation" -->
                            @if (selectedPartner?.ContactManagers[0]?.FirstName || selectedPartner?.ContactManagers[0]?.LastName) {
                              <div class="line">
                                {{selectedPartner?.ContactManagers[0]?.FirstName + ' ' + selectedPartner?.ContactManagers[0]?.LastName}}
                              </div>
                            }
                          </div>
                        </div>
                      }
                      @if (selectedPartner.AreaManager) {
                        <div class="manager-container AreaManager">
                          <img alt="Contact" src="{{selectedPartner?.AreaManager?.AvatarURL}}">
                          <div class="manager-info">
                            <div class="line" fiTranslation="REQUEST_DETAIL_HEADLINE_EXTERNAL_DEALER_AREA_SALES_MANAGER"></div>
                            <!-- *ngIf="selectedPartner?.AreaManager?.Organisation" -->
                            @if (selectedPartner?.AreaManager?.FirstName || selectedPartner?.AreaManager?.LastName) {
                              <div class="line">
                                {{selectedPartner?.AreaManager?.FirstName + ' ' + selectedPartner?.AreaManager?.LastName}}
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <div>
        <div class="field-title" fiTranslation="ACTION_GENERAL_HEADLINE_REQUEST_NOTE"></div>
        <fi-editor
          [noUploads]="true"
          [placeholderTranslation]="'REQUEST_DETAIL_NOTE_PLACEHOLDER'"
          (isLongDescription)="inValidNote = $event"
          (textChanged)="note = $event">
        </fi-editor>
      </div>
    </div>
  </div>

  <div class="footer">
    <button (click)="submit()" [disabled]="!formIsValid">
      <img [src]="iconUrl" alt="Action icon">
      @if (!selectedPartner) {
        <span> {{title}} </span>
      }
      @if (selectedPartner) {
        <span fiTranslation="ACTION_LEAD_FORWARD_EXTERNAL_HEADER"></span>
      }
      @if (selectedPartner) {
        <span class="external" fiTranslation="External"></span>
      }
    </button>
  </div>
</div>

@if (selectActive) {
  <div class="overlay active" (click)="onOverlayClick()"></div>
}

